window.SwymCallbacks = window.SwymCallbacks || [];

window.SwymCallbacks.push(function (swat) {
  if (!window.SwymWishlistSync) {
    return;
  }

  var hasCustomWishlist = !!document.querySelector('.swymcs-custom-wishlist');
  var hasNativeWishlistGrid = !!document.querySelector('.swym-wishlist-grid');

  window.SwymWishlistSync.init(swat, function () {
    if (hasNativeWishlistGrid && !hasCustomWishlist) {
      window.setTimeout(function () {
        swat.fetch(function () {
          window.SwymWishlistSync.refresh(true);
        });
      }, 120);
      return;
    }

    window.SwymWishlistSync.refresh(true);
  });

  if (hasCustomWishlist || hasNativeWishlistGrid) {
    window.SwymWishlistSync.refresh(true);
  }
});
